import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const PLACEHOLDER_JSON = `{
  "vendor_name": "Acme Corp",
  "invoice_number": "INV-001",
  "amount": "1500.00"
}`;

/**
 * Formats a byte count into a human-readable string.
 * @param {number} bytes
 * @returns {string}
 */
const formatBytes = (bytes) => {
  if (bytes < 1024) return `${bytes} bytes`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(2)} MB`;
};

const JsonInputPanel = ({ value, onChange, error, disabled }) => {
  const sizeInBytes = value ? new Blob([value]).size : 0;

  return (
    <div>
      <textarea
        id="jsonInputPanel"
        aria-label="Sample JSON Input"
        className="form-control"
        style={{ fontFamily: 'monospace', width: '100%' }}
        rows={12}
        placeholder={PLACEHOLDER_JSON}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
      <div className="d-flex justify-content-between align-items-center mt-1">
        <small className="text-muted">
          {formatBytes(sizeInBytes)} / 1 MB
        </small>
      </div>
      {error && (
        <Alert variant="danger" className="mt-2 mb-0 py-2 px-3">
          {error}
        </Alert>
      )}
    </div>
  );
};

JsonInputPanel.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

export default JsonInputPanel;
